<template>

  <v-dialog v-model="open" persistent max-width="500px">
    <v-card v-if="open">
    <v-card-title>
      <span>{{dialogTitle}}</span>
      <v-spacer></v-spacer>
    </v-card-title>
    <v-container grid-list-lg text-xs-left>
      <v-layout column wrap>
        <v-flex>
          <div class="c-msg">{{dialogMsg}}</div>
        </v-flex>
        <v-flex>
          <select-member-single
            ref="select_member_single"
            :label= "label"
            itemText="nickname"
            itemValue="id"
            :initItems="items"
            :initValue="selected"
            subContent="role"
            :no-data-text="$T('common.no_data')"
            @change-value="onChangeValue"
          />
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="clr-btn-cancel" flat @click.native="closeDialog">{{$T('button.close')}}</v-btn>
      <v-btn color="clr-btn" flat @click.native="save" :disabled="!isSavable" :loading="loading">{{$T('button.save')}}</v-btn>
    </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>
  import selectMemberSingle from "./SelectMemberSingle.vue";

  export default {
    components: {
      'select-member-single': selectMemberSingle,
    },
  	props: {
  	},
    watch: {

    },
    data() {
      return {
        open: false,
        key: null,
        dialogTitle: null,
        dialogMsg: null,
        label: null,
        loading: false,
        apiErrors: {},
        isUpdating: false,
        items: null,
        selected: null,
      }
    },
    computed: {
      isSavable() {
        return this.selected;
      },
    },
    methods: {
      openDialog(key, dialogTitle, dialogMsg, label, items, selected) {
        this.key = key,
        this.dialogTitle = dialogTitle;
        this.dialogMsg = dialogMsg;
        this.label = label;
        this.items = items;
        this.selected = selected;
        this.loading = false;
        this.open = true;
      },
      closeDialog() {
        this.loading = false;
        this.open = false;
      },
      save() {
        this.loading = true;
        this.$emit('save', this.key, this.selected);
      },
      onChangeValue(newValue, oldValue) {
        this.selected = newValue;
      },
    },
  }
</script>

<style scoped>
  .container {
    padding: 8px 24px 24px 24px;
  }
</style>
